export default __webpack_public_path__ + "static/media/diamond-1.fe08a8fe.png";